export const getDatabaseMembers = state => state.companies.databaseMembers;
export const getShowNewCallListModal = state => state.companies.startNewCallList;
